import { render } from "./Praise.vue?vue&type=template&id=16dbc4df&scoped=true&ts=true"
import script from "./Praise.vue?vue&type=script&lang=ts"
export * from "./Praise.vue?vue&type=script&lang=ts"

import "./Praise.vue?vue&type=style&index=0&id=16dbc4df&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16dbc4df"]])

export default __exports__